import { makeStyles } from '@mui/styles';
import { useEffect, useState } from 'react';
import NRCursorPaginationStyles from './NRCursorPagination.styles';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

const useStyles = makeStyles(NRCursorPaginationStyles);

function NRCursorPagination({
  params,
  pageInfo,
  handleFetchMore,
  handleSetPageSize,
  pageSizes = [10, 25, 100],
  defaultPageSize = 10,
  nextContent = 'NEXT',
  prevContent = 'PREV'
}) {
  const classes = useStyles();
  const [pageSize, setPageSize] = useState(defaultPageSize);

  const handleChange = event => {
    setPageSize(event.target.value);
    !!handleSetPageSize && handleSetPageSize(event.target.value);
  };

  useEffect(() => {
    handleFetchMore({ cursor: { first: pageSize, before: null, after: null }, firstTime: true });
  }, [pageSize]);

  return (
    <Box className={classes.card}>
      <FormControl size="small" variant="standard" className={classes.select}>
        <Select disableUnderline labelId="page-size-label" id="page-size" value={pageSize} onChange={handleChange} label="Rows per page">
          {pageSizes.map(value => (
            <MenuItem key={value} value={value}>
              {value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button
        className={'classes.primaryButton'}
        variant="text"
        color="secondary"
        disabled={!pageInfo.hasPreviousPage}
        onClick={() =>
          handleFetchMore({
            cursor: { last: pageSize, before: pageInfo.startCursor, after: null, first: null }
          })
        }
      >
        {prevContent}
      </Button>
      <Button
        className={'classes.primaryButton'}
        variant="text"
        color="secondary"
        disabled={!pageInfo.hasNextPage}
        onClick={() =>
          handleFetchMore({
            cursor: { first: pageSize, after: pageInfo.endCursor, before: null }
          })
        }
      >
        {nextContent}
      </Button>
    </Box>
  );
}
export default NRCursorPagination;
